module.exports = __webpack_public_path__ + "fonts/ToyotaType-Italic.b000b2a.woff2";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/ToyotaType-Italic.woff2
// module id = dn/r
// module chunks = 13